import { render, staticRenderFns } from "./ApproveSetting.vue?vue&type=template&id=5e243e37&scoped=true&"
import script from "./ApproveSetting.vue?vue&type=script&lang=js&"
export * from "./ApproveSetting.vue?vue&type=script&lang=js&"
import style0 from "./ApproveSetting.vue?vue&type=style&index=0&id=5e243e37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e243e37",
  null
  
)

export default component.exports